import { ColumnViewModel } from '../../shared/column-types';

export const numberChemsIncludedInEvidenceVDA_SUMMARY: ColumnViewModel = {
  columns: [
    'chemID',
    'chemPrefName',
    'chemNumVDAs',
    'chemNumPublicationsVDA',
    'chemNumPublicationsVDAs',
    'chemNumGDAs',
    'chemNumPublicationsGDAs',
    'chemNumPublications',
  ],
  defaultVisible: [
    'chemPrefName',
    'chemNumVDAs',
    'chemNumPublicationsVDA',
    'chemNumPublicationsVDAs',
    'chemNumGDAs',
    'chemNumPublicationsGDAs',
  ],
};

export const numChemicalsDISEASES_SUMMARY: ColumnViewModel = {
  columns: [
    'chemID',
    'chemPrefName',
    'chemNumGDAs',
    'chemNumPublicationsGDAs',
    'chemNumVDAs',
    'chemNumPublicationsVDAs',
    'chemNumPublications',
  ],
  defaultVisible: [
    'chemID',
    'chemPrefName',
    'chemNumGDAs',
    'chemNumPublicationsGDAs',
    'chemNumVDAs',
    'chemNumPublicationsVDAs',
    'chemNumPublications',
  ],
};